export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  legend: string;
  value: T;
  options: readonly SegmentedOption<T>[];
  onChange: (value: T) => void;
}

/**
 * 沒有第三方元件庫的最小 pill 切換器。
 * shadcn/ui（Radix）在 P2 才複製進來——P0 不需要為了三個按鈕背一套元件系統。
 */
export function SegmentedControl<T extends string>({
  legend,
  value,
  options,
  onChange,
}: SegmentedControlProps<T>) {
  return (
    <fieldset className="flex shrink-0 items-center gap-2 border-0 p-0">
      <legend className="sr-only">{legend}</legend>
      <span className="hidden whitespace-nowrap text-11 text-muted md:inline" aria-hidden="true">{legend}</span>
      <div className="flex glass rounded-pill p-0.5" role="group">
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={active}
              onClick={() => {
                onChange(option.value);
              }}
              className={[
                'whitespace-nowrap rounded-pill px-2.5 py-2.5 text-12 sm:px-3 sm:py-1 sm:text-13',
                active
                  ? 'glass-strong font-semibold text-fg-1'
                  : 'text-fg-2 hover:text-fg-1',
              ].join(' ')}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
